export default __webpack_public_path__ + "static/media/gallery03.4a393bf2.jpg";